var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 120,
    viewBox: "0 0 493 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.903 84.7413C166.982 84.7413 157 74.6544 157 60.4805C157 46.1326 167.244 36.0457 181.429 36.0457C190.622 36.0457 198.765 40.6544 202.355 48.0457L198.064 50.4805C194.912 44.6544 188.696 40.8283 181.429 40.8283C170.396 40.8283 162.253 48.9152 162.253 60.4805C162.253 71.8718 170.134 79.9587 180.903 79.9587C188.17 79.9587 194.825 75.8718 197.802 70.3065L202.092 72.9152C198.327 80.1326 190.009 84.7413 180.903 84.7413Z",
    fill: "#1C8578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.7 84.8283C216.603 84.8283 206.359 74.0457 206.359 60.3935C206.359 46.8283 216.603 36.0457 230.7 36.0457C244.796 36.0457 255.041 46.8283 255.041 60.3935C255.041 74.0457 244.796 84.8283 230.7 84.8283ZM230.7 80.0457C241.732 80.0457 249.787 71.35 249.787 60.3935C249.787 49.5239 241.732 40.8283 230.7 40.8283C219.755 40.8283 211.612 49.5239 211.612 60.3935C211.612 71.35 219.755 80.0457 230.7 80.0457Z",
    fill: "#1C8578"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.134 36.0457H309.106L288.355 83.6109H277.585L256.922 36.0457H272.069L283.189 65.2631L294.134 36.0457Z",
    fill: "#204047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.473 31.1761C314.832 31.1761 311.242 27.6978 311.242 23.0892C311.242 18.4805 314.92 15.0022 319.473 15.0022C324.113 15.0022 327.703 18.4805 327.703 23.0892C327.703 27.6978 324.113 31.1761 319.473 31.1761ZM326.302 83.6978H312.556V36.0457H326.302V83.6978Z",
    fill: "#204047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M369.146 17.5239H382.892V83.6978H369.584V78.5674C366.344 82.2196 361.791 84.9152 355.312 84.9152C341.915 84.9152 331.671 74.3065 331.671 59.8718C331.671 45.5239 341.915 34.8283 355.312 34.8283C361.528 34.8283 365.906 37.35 369.146 40.6544V17.5239ZM357.588 72.4805C364.855 72.4805 369.846 66.8283 369.846 59.7848C369.846 52.9152 364.855 47.2631 357.588 47.2631C350.321 47.2631 345.33 52.9152 345.33 59.7848C345.33 66.8283 350.321 72.4805 357.588 72.4805Z",
    fill: "#204047"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M438.116 58.7413C438.116 60.6544 437.941 62.5674 437.678 64.4805H402.392C403.881 69.6978 407.996 73.437 415.438 73.437C420.604 73.437 426.558 71.437 430.411 68.8283L435.839 78.1326C431.199 81.6109 423.756 84.7413 414.826 84.7413C396.876 84.7413 388.558 72.7413 388.558 59.7848C388.558 45.6109 398.627 34.8283 413.862 34.8283C427.609 34.8283 438.116 43.6109 438.116 58.7413ZM413.862 45.8718C408.259 45.8718 403.881 49.1761 402.305 54.7413H424.895C423.669 49.35 419.641 45.8718 413.862 45.8718Z",
    fill: "#204047"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M466.995 85.0022C451.498 85.0022 441.166 73.6978 441.166 59.8718C441.166 46.0457 451.498 34.7413 466.995 34.7413C482.581 34.7413 493 46.0457 493 59.8718C493 73.6978 482.581 85.0022 466.995 85.0022ZM466.995 72.3065C473.912 72.3065 479.253 66.8283 479.253 59.7848C479.253 52.9152 473.912 47.437 466.995 47.437C460.166 47.437 454.825 52.9152 454.825 59.7848C454.825 66.8283 460.166 72.3065 466.995 72.3065Z",
    fill: "#204047"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.631 93.5626V25.9678L31.1133 9.09888L0 39.9981V79.9931L31.1133 111.1L57.631 93.5626Z",
    fill: "#1C8578"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8623 59.0064L133 58.8281V39.9972L92.9629 0.00219727H40.2249L31.0635 9.09806L91.8623 59.0064Z",
    fill: "url(#paint0_linear_2_4268)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8623 59.0087L31.0635 111.102L39.9721 120.004H92.9629L133 79.9946V58.8303L91.8623 59.0087Z",
    fill: "#11A694"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4268",
    x1: 69.8245,
    y1: 6.26764,
    x2: 104.397,
    y2: 58.1119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0483,
    stopColor: "#11A694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FE0C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingLogoDark);
export default __webpack_public_path__ + "static/media/brandingLogoDark.e51b1d727df1d187c3eb624697b2a6af.svg";
export { ForwardRef as ReactComponent };